import { GdasClaimsData, GdasProfile, GdasSellersData } from "./gdas";

export enum AccountType {
  AAD = "aad",
  MSA = "msa",
}

export type UserInfo = {
  emailAddress: string; // UPN/UserName
  graphEmailAddress?: string; // claims.email (AAD Graph mail; may be absent)
  puid?: string; // idTokenClaims.puid (Live PUID; EDS primary key, may be absent)
  tid?: string; // TenantID
  sellerIds?: string[]; // GDAS seller IDs, with AMS email lookup fallback in local dev
  accountType: AccountType;
  displayName?: string;
  avatarImage: string;
  firstName?: string;
  lastName?: string;
};

export type UserData = {
  isFetched: boolean;
  userInfo: UserInfo | undefined;
  gdasProfile: GdasProfile | undefined;
  gdasSellers: GdasSellersData | undefined;
  gdasClaims: GdasClaimsData | undefined;
};
